import { memo } from 'react';

import { Link } from '@tanstack/react-router';

import type { RemoveItemHandler } from '@/_components';
import { Avatar, AvatarFallback, AvatarImage } from '@/_components';
import { DeleteButton } from '@/_containers';

import { type ContactQueryLinkerSchema } from '../../schemas';

type ContactItemProps = {
  item: ContactQueryLinkerSchema;
  isEditable?: boolean;
  removeItemHandler: RemoveItemHandler<ContactQueryLinkerSchema>;
};

function ContactItemBase({ item, isEditable = false, removeItemHandler }: ContactItemProps) {
  const { id, first_name, last_name, profile_image } = item;
  const fullName = `${first_name}${last_name ? ` ${last_name}` : ''}`;

  const handleDeleteContact = async () => {
    removeItemHandler(item);
  };

  return (
    <div className="border-c-border-muted text-accent flex h-11 flex-nowrap items-center justify-between border-b dark:text-white">
      <div className="flex items-center gap-1.5">
        <Link
          to="/contacts/$id"
          params={{ id: `${id}` }}
          state={{ naturalBack: true }}
          className="group flex items-center gap-2"
        >
          <Avatar size="sm">
            <AvatarImage src={profile_image?.at(0)?.url} className="object-cover" />
            <AvatarFallback name={fullName} className="text-xs" />
          </Avatar>
          <span className="decoration-primary text-sm decoration-2 group-hover:underline">{fullName}</span>
        </Link>
      </div>
      {isEditable && (
        <DeleteButton
          type="icon"
          size="sm"
          title="Remove Contact?"
          text="The Contact record will not be deleted; only its association will be removed."
          yesButton="Yes, Remove"
          aria-label="Remove contact"
          callback={handleDeleteContact}
        />
      )}
    </div>
  );
}

export const Item = memo(ContactItemBase);
